import CatalogTypes from './catalogTypes';

class LayerDtoWrapper {
  constructor(url, visible) {
    this._url = url;
    this._visible = visible;
  }

  get visible() {
    return this._visible;
  }

  set visible(value) {
    this._visible = value;
  }

  get url() {
    return this._url;
  }
}

class CatalogLayerDtoWrapper {
  constructor(catalogDto, layerDtoWrapper) {
    this._catalogDto = catalogDto;
    this._layerDtoWrapper = layerDtoWrapper;
    this._opacityPercent = 100;
    this._infoSetKeys = null;
  }

  get url() {
    return this._infoSetKeys
      ? `${this._layerDtoWrapper.url}${encodeURI(
          `&CQL_FILTER=info_set_key in (${this._infoSetKeys.join(',')})`
        )}`
      : this._layerDtoWrapper.url;
  }

  get name() {
    return this._catalogDto.value;
  }

  get displayName() {
    return this._catalogDto.name;
  }

  get visible() {
    return this._layerDtoWrapper.visible;
  }

  set visible(value) {
    this._layerDtoWrapper.visible = value;
  }

  get children() {
    return this._catalogDto.children;
  }

  get type() {
    return this._catalogDto.type;
  }

  get id() {
    return this._catalogDto.id;
  }

  get opacityPercent() {
    return this._opacityPercent;
  }
  set opacityPercent(value) {
    this._opacityPercent = value;
  }
  get opacity() {
    return this._opacityPercent / 100;
  }
  set infoSetKeys(value) {
    this._infoSetKeys = value;
  }
  get infoSetKeys() {
    return this._infoSetKeys;
  }
}

class LayerCatalogConverter {
  static fromDto(projectSchema, formatUrlTile, catalog, layersDictionary) {
    if (!catalog.children) return;
    if (!layersDictionary)
      //потому что один и тотже слой может встречаться дважды в разных каталогах. в этом словаре запоминаем инстансы каталогов слоёв по именам
      layersDictionary = {};

    catalog.children.forEach((c, index) => {
      if (c.type === CatalogTypes.LAYER) {
        const layerName = c.value;
        if (!layersDictionary[layerName]) {
          const url = formatUrlTile(projectSchema, layerName);
          layersDictionary[layerName] = new LayerDtoWrapper(url, c.isOpen);
        }
        catalog.children[index] = new CatalogLayerDtoWrapper(
          c,
          layersDictionary[layerName]
        );
      }
      LayerCatalogConverter.fromDto(
        projectSchema,
        formatUrlTile,
        c,
        layersDictionary
      );
    });
  }
}

export default LayerCatalogConverter;
